import { render, staticRenderFns } from "./TwoDimensionalTestResult.vue?vue&type=template&id=4195cd9f&scoped=true&"
import script from "./TwoDimensionalTestResult.vue?vue&type=script&lang=js&"
export * from "./TwoDimensionalTestResult.vue?vue&type=script&lang=js&"
import style0 from "./TwoDimensionalTestResult.vue?vue&type=style&index=0&id=4195cd9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195cd9f",
  null
  
)

export default component.exports